/**
 * helper to trigger callbacks
 * depending on the animation progress
 * @param {*} progressObj
 * @returns {function}
 */
export function handleAnimationProgressCbs(progressObj) {
  const progressEntries = Object.entries(progressObj || {});
  if (!progressEntries.length) {
    return () => {};
  }

  return function (anim) {
    const progress = Math.round(anim.progress);
    progressEntries.forEach(([progressToCall, cb], i) => {
      if (progress >= progressToCall) {
        cb(anim);
        // NOTE: splice mutates original array
        progressEntries.splice(i, 1);
      }
    });
  };
}

export function setGlobalAnimateClassName() {
  document.documentElement.classList.add('animate');
}
